import React from 'react';
import {
  FormControl,
  FormControlLabel,
  TextField,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

const styles = {
  textFieldContainer: {
    flex: 1,
  },
  textField: {
    width: 54,
    height: 0,
    paddingBottom: 34,
    margin: 0,
  },
};

function BaseFeatureFlagNumber({
  onChange, label, value, max,
}) {
  return (
    <FormControl fullWidth>
      <FormControlLabel
        labelPlacement="start"
        sx={{ ml: 0 }}
        label={(
          <Typography style={styles.textFieldContainer}>
            { label }
          </Typography>
        )}
        control={(
          <TextField
            type="number"
            placeholder="--"
            value={value}
            variant="standard"
            InputProps={{ inputProps: { min: 1, max } }}
            style={styles.textField}
            onChange={onChange}
          />
        )}
      />
    </FormControl>
  );
}

BaseFeatureFlagNumber.defaultProps = {
  max: Number.MAX_SAFE_INTEGER,
};
BaseFeatureFlagNumber.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  max: PropTypes.number,
};

const FeatureFlagNumber = withRouter(BaseFeatureFlagNumber);
export { BaseFeatureFlagNumber, FeatureFlagNumber };
